import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import SideBar from "./components/SideBar";

const AppLayout = () => {
    return (
        <div style={{ display: 'flex' }}>
            <Box>
                <SideBar />
            </Box>
            <Box component="main" className="mainBox full-height" sx={{ flexGrow: 2, backgroundColor: '#D2E3DD' }}>
                {<Outlet />}
            </Box>
        </div>
    )
}

export default AppLayout